module.exports = __webpack_public_path__ + "img/7.bb5cbd99.jpg";